export const CHECKOUT_URL = '#checkout'

export const heroMockup = {
  src: 'https://cdn.magicpatterns.com/uploads/7SKQdUGnEGDvLCnK4HPMAF/flag-football-ready-transparente.png',
  alt: 'Flag Football Ready complete collection: 10 volumes and 5 bonuses',
}

export const trustBadges = [
  { icon: 'download', label: 'Instant digital access' },
  { icon: 'lock', label: 'Secure payment' },
  { icon: 'file', label: 'PDF format — read on any device or print' },
]

export const keyNumbers = [
  { value: '600', label: 'Pages' },
  { value: '10', label: 'Volumes' },
  { value: '5', label: 'Bonuses' },
  { value: '5–18', label: 'Ages covered' },
]

export const problems = [
  'You spend hours every week planning practices from scratch.',
  'Kids get bored standing in lines instead of playing.',
  "You're not sure which skills to teach at each age.",
  "You don't have plays and defenses that actually fit your team.",
  'Practices feel disorganised and parents notice.',
  "You're a volunteer or PE teacher and nobody gave you a system.",
]

export const levelTags = [
  'Ages 5–6',
  '7–8',
  '9–10',
  '11–12',
  '13–14',
  '15–18',
  'All levels',
]

export const volumes = [
  {
    tag: 'VOLUME 1',
    title: 'First Flags',
    age: 'Ages 5–6',
    bullets: [
      'Games-based introduction to flag pulling, carrying and first catches',
      '8 session plans',
      'Flashcards and progress cards',
    ],
  },
  {
    tag: 'VOLUME 2',
    title: 'Fundamentals',
    age: 'Ages 7–8',
    bullets: [
      'Throwing and catching on the move',
      'First routes and man-to-man defense',
      'First 5v5 games with play cards',
    ],
  },
  {
    tag: 'VOLUME 3',
    title: 'Skill Builder',
    age: 'Ages 9–10',
    bullets: ['Quarterback footwork and reads', '8-route tree', 'Man and zone defense'],
  },
  {
    tag: 'VOLUME 4',
    title: 'Game Sense',
    age: 'Ages 11–12',
    bullets: [
      'Route concepts and progressions',
      'Cover 1, Cover 2 and Blitz',
      'Play-calling by situation',
    ],
  },
  {
    tag: 'VOLUME 5',
    title: 'Competitive Play',
    age: 'Ages 13–14',
    bullets: [
      'Systems, tempo and hand signals',
      'New coverages and rush moves',
      'Two-minute drill and overtime',
    ],
  },
  {
    tag: 'VOLUME 6',
    title: 'Advanced & High School',
    age: 'Ages 15–18',
    bullets: [
      'Advanced concepts and 7v7',
      'Pressure packages and rotations',
      'Playbook, game week and championship prep',
    ],
  },
  {
    tag: 'VOLUME 7',
    title: 'Offense Playbook & Drill Bank',
    age: 'All ages',
    bullets: ['24 offensive drills', '23 plays by level', 'Play-selection charts'],
  },
  {
    tag: 'VOLUME 8',
    title: 'Defense Playbook & Drill Bank',
    age: 'All ages',
    bullets: ['22 defensive drills', '21 defensive calls', 'Coverage vs play charts'],
  },
  {
    tag: 'VOLUME 9',
    title: 'Flag Football in PE Class',
    age: 'Schools',
    bullets: [
      '4 units, 24 ready-to-teach lessons',
      'Assessment rubrics',
      'Inclusion and large-group tools',
    ],
  },
  {
    tag: 'VOLUME 10',
    title: 'Season Planner & Coaching Toolkit',
    age: 'All ages',
    bullets: [
      'Season and practice templates',
      'Parent and game-day tools',
      'Safety and end-of-season resources',
    ],
  },
]

export const volumeFeatureTags = [
  'Session plans',
  'Playbooks',
  'Drill banks',
  'Printable sheets',
  'Assessment rubrics',
  'Quizzes with answer keys',
]

export const bonuses = [
  {
    tag: 'Bonus 1',
    value: '$15',
    title: 'Rainy Day Flag Football: Indoor & Small-Space Sessions',
    description: '20 indoor activities and 6 ready sessions.',
    image:
      'https://cdn.magicpatterns.com/uploads/iEBfUp2cVmnEz8suo8q9zf/00cd756c-f3aa-47eb-8265-741bc0b812d0-mockup.webp',
    imageAlt: 'Rainy Day Flag Football: Indoor & Small-Space Sessions book cover',
  },
  {
    tag: 'Bonus 2',
    value: '$20',
    title: 'Speed & Agility Lab',
    description: 'Age-appropriate speed, agility and fitness programmes.',
    image:
      'https://cdn.magicpatterns.com/uploads/1VrzQ15DhyiHPb6vddTpH5/fa9dbe7d-55db-4c6e-9eea-afd1162a33d1-mockup.webp',
    imageAlt: 'Flag Football Speed & Agility Lab book cover',
  },
  {
    tag: 'Bonus 3',
    value: '$27',
    title: 'Quarterback Academy',
    description: 'The complete QB development programme with 12 drills.',
    image:
      'https://cdn.magicpatterns.com/uploads/qJaDPjsS41YCosyPF71w3h/0619a4e5-87ad-4647-99ac-3b3942fad90b-mockup.webp',
    imageAlt: 'Quarterback Academy book cover',
  },
  {
    tag: 'Bonus 4',
    value: '$17',
    title: '40 Fun Flag Football Games',
    description: 'Warm-ups, flag-pulling games and mini games.',
    image:
      'https://cdn.magicpatterns.com/uploads/jggA2gWtpyMmwd13JSVrGe/e439ac72-5589-4a93-b3bd-662044713cb5-mockup.webp',
    imageAlt: '40 Fun Flag Football Games book cover',
  },
  {
    tag: 'Bonus 5',
    value: '$15',
    title: 'Flag Football Rules Made Simple',
    description: 'Rules explained for coaches, parents and young referees.',
    image:
      'https://cdn.magicpatterns.com/uploads/hChdYPWAx8VpyaHHo5NTpA/ab0fd1dc-b263-4a4b-83ab-78b915a9c120-mockup.webp',
    imageAlt: 'Flag Football Rules Made Simple: The Coach, Parent and Referee Guide book cover',
  },
]

export const pricingIncludes = [
  '10 complete volumes',
  '5 strategic bonuses',
  '600 pages',
  'Ages 5–18',
  'Instant digital access',
  'Print-ready PDFs',
]

export const playbookFeatures = [
  { icon: 'offense', title: '23 offensive plays by level' },
  { icon: 'defense', title: '21 defensive calls' },
  { icon: 'drills', title: '46 drills with diagrams' },
  { icon: 'charts', title: 'Charts to choose the right play or coverage' },
]

export const audiences = [
  { icon: 'volunteer', title: 'Volunteer and parent coaches' },
  { icon: 'club', title: 'Club and league coaches' },
  { icon: 'pe', title: 'PE teachers' },
  { icon: 'school', title: 'High school programmes' },
]

export const faqs = [
  {
    question: 'What exactly is Flag Football Ready?',
    answer:
      'A digital collection of 10 PDF volumes and 5 bonuses with sessions, playbooks, drills, PE lessons and season tools for players aged 5–18.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. It is 100% digital. You receive PDF files; nothing is shipped.',
  },
  {
    question: 'How do I receive it?',
    answer: 'After purchase you get access to download the PDFs.',
  },
  {
    question: 'Which ages does it cover?',
    answer: 'Ages 5 to 18, from first-time players to high school teams.',
  },
  {
    question: 'Does it work for 5v5 and 7v7?',
    answer:
      "Yes. The volumes use 5v5 as the base and include notes for 7v7. Always follow your league's rules.",
  },
  {
    question: "I'm a PE teacher. Is it useful for me?",
    answer:
      'Yes. Volume 9 has 4 units with 24 ready-to-teach lessons and assessment tools.',
  },
  {
    question: 'Can I print the materials?',
    answer: 'Yes. The PDFs are designed to be read on screen or printed.',
  },
  {
    question: 'Is it affiliated with any league?',
    answer: 'No. Flag Football Ready is an independent coaching resource.',
  },
]

export const footerLinks = [
  { label: 'Terms', href: '#' },
  { label: 'Privacy', href: '#' },
  { label: 'Contact', href: '#' },
]
